<template>
  <LegacyBlogPage v-if="isLegacyBlog" />
  <BlogMain v-else-if="!isLegacyBlog" />
</template>

<script setup>
import LegacyBlogPage from "~/components/legacy/LegacyBlogPage.vue";
import BlogMain from "~/components/blog/BlogMainPage.vue";
const router = useRouter();
const route = router.currentRoute;
const { getLocale } = useFunctions();
definePageMeta({
  pageInfo: {
    name: "blog-detail",
  },
});
const isLegacyBlog = ref(false);
const { data: response } = await useApiFetch("/api/is-legacy-blog", {
  method: "POST",
  fetchKey: "is-legacy-blog",
  body: {
    locale: getLocale(),
    slug: route.value.params?.blogSlug,
  },
});
isLegacyBlog.value = response.value?.is_legacy;
</script>
